import { createSelector } from '@ngrx/store';
import { getMsRegistrationState } from '../reducers';

export const getMsRegistrationFormState = createSelector(
  getMsRegistrationState,
  (state) => state.msRegistrationForm
);

export const getToken = createSelector(
  getMsRegistrationFormState,
  ({ token }) => token
);

export const getQcCode = createSelector(
  getMsRegistrationFormState,
  ({ qcCode }) => qcCode
);

export const getMessage = createSelector(
  getMsRegistrationFormState,
  ({ message }) => message
);

export const getShowMessageStatus = createSelector(
  getMsRegistrationFormState,
  ({ showMessage }) => showMessage
);

export const getFirstName = createSelector(
  getMsRegistrationFormState,
  ({ firstName }) => firstName.value
);

export const getEmail = createSelector(
  getMsRegistrationFormState,
  ({ email }) => email.value
);

export const getFName = createSelector(
  getMsRegistrationFormState,
  ({ fName }) => fName
);

export const getLName = createSelector(
  getMsRegistrationFormState,
  ({ lName }) => lName
);

export const getCNumber = createSelector(
  getMsRegistrationFormState,
  ({ cNumber }) => cNumber
);
